import { render, staticRenderFns } from "./ProductsView.vue?vue&type=template&id=316807e3&scoped=true&"
import script from "./ProductsView.vue?vue&type=script&lang=ts&"
export * from "./ProductsView.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsView.vue?vue&type=style&index=0&id=316807e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316807e3",
  null
  
)

export default component.exports